import { Dispatch, SetStateAction } from 'react';
import Card from '../../../../shared/card/Card';
import ImageGallery from './ImageGallery';
import { Property } from '../../../../../models/Property';
import SummaryStatistics from './SummaryStatistics';
import OverviewDescription from './OverviewDescription';
import ContactSection from './ContactSection';

interface GeneralInformationProps {
  property: Property;
  setShowImageModal: Dispatch<SetStateAction<boolean>>;
}

export default function GeneralInformation({property, setShowImageModal}: GeneralInformationProps) {
  return (
    <section className='general-info'>
      <Card>
        <ImageGallery
          property={property}
          setShowImageModal={setShowImageModal}
        />
        <OverviewDescription property={property}/>
        <div className="divider"></div>

        <ContactSection property={property} />
        <div className="divider"></div>

        <SummaryStatistics property={property} />
      </Card>
    </section>
  );
}
